import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 359CB8BA-79AF-43F7-AE85-562432388C2E
 * name horse-variant
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/horse-variant.svg
 * tags
 * - Animal 
 * - Agriculture 
 */
export const HorseVariantIcon = createSvgIcon(<><path d="M20 8V16L17 17L13.91 11.5C13.65 11.04 12.92 11.27 13 11.81L14 21L4 17L5.15 8.94C5.64 5.53 8.56 3 12 3H20L18.42 5.37C19.36 5.88 20 6.86 20 8Z" /></>, 'HorseVariantIcon');
export default HorseVariantIcon